import { Toolbar, Divider, List, ListItemButton, ListItemIcon, ListItemText, Box, CssBaseline, AppBar, IconButton, Menu, MenuItem, Drawer, Button, Typography, Collapse, BottomNavigation, BottomNavigationAction, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import React, { useContext } from 'react';
import HttpService from '../../services/HttpService';
import { AccountCircle, EmojiEventsOutlined, EventOutlined, GroupsOutlined, HomeOutlined, InfoOutlined, List as ListIcon, Person2Outlined, RedoOutlined, SettingsOutlined, SmartDisplayOutlined, TodayOutlined } from '@mui/icons-material';
import {Route, Routes, useNavigate, NavLink, useLocation} from 'react-router-dom';
import { Account } from '../../types/Common';
import { AppContext } from '../../App';
import { AllocRole } from '../../types/Saison';
import AccountDialogComponent from './AccountDialogComponent';
import ImageComponent from './ImageComponent';
import ChangeSizeDialogComponent from './ChangeSizeDialogComponent';
import { ReactComponent as Logo } from '../../res/images/Logo.svg'
import Logo2 from '../../res/images/Logo2.png'

const HomePage = React.lazy(() => import('../../routes/HomePage'));
const ErrorPage = React.lazy(() => import('../../routes/ErrorPage'));
const SaisonPage = React.lazy(() => import('../../routes/SaisonPage'));
const TeamPage = React.lazy(() => import('../../routes/TeamPage'));
const MatchDayPage = React.lazy(() => import('../../routes/MatchDayPage'));
const MatchPage = React.lazy(() => import('../../routes/MatchPage'));
const MatchDaysPage = React.lazy(() => import('../../routes/MatchDaysPage'));
const TeamPlayersPage = React.lazy(() => import('../../routes/TeamPlayersPage'));
const AdministrationPage = React.lazy(() => import('../../routes/AdministrationPage'));
const PlayersPage = React.lazy(() => import('../../routes/PlayersPage'));
const TeamsPage = React.lazy(() => import('../../routes/TeamsPage'));
const SaisonsPage = React.lazy(() => import('../../routes/SaisonsPage'));
const InfoPage = React.lazy(() => import('../../routes/InfoPage'));
const HallOfFame = React.lazy(() => import('../../routes/HallOfFame'));
const ImpressumPage = React.lazy(() => import('../../routes/ImpressumPage'));
const PrivacyPage = React.lazy(() => import('../../routes/PrivacyPage'));
const TeamPlayerSuggestsPage = React.lazy(() => import('../../routes/TeamPlayerSuggestsPage'));
const PlayersTradeLivePage = React.lazy(() => import('../../routes/PlayersTradeLivePage'));
const UsersPage = React.lazy(() => import('../../routes/UsersPage'));

interface Props {
    window?: () => Window;
    onLogout: Function;
    onLogin: Function;
    account: Account | undefined;
}

function ResponsiveDrawer(props: Props) {

    const { window, onLogout, onLogin, account } = props;
    const DESKTOP_DRAWER_STORAGE_KEY = 'desktopDrawerOpen';
    const DESKTOP_DRAWER_WIDTH_OPEN = 240;
    const DESKTOP_DRAWER_WIDTH_MINI = 64;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [desktopDrawerOpen, setDesktopDrawerOpen] = React.useState<boolean>(() => {
        try {
            const stored = localStorage.getItem(DESKTOP_DRAWER_STORAGE_KEY);
            if (stored === null) return true;
            return stored === 'true';
        } catch {
            return true;
        }
    });
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [openAccountDialog, setOpenAccountDialog] = React.useState(false)
    const [openChangeSizeDialog, setOpenChangeSizeDialog] = React.useState(false)

    const navigate = useNavigate();
    const location = useLocation();

    React.useEffect(() => {
        try { localStorage.setItem(DESKTOP_DRAWER_STORAGE_KEY, String(desktopDrawerOpen)); } catch {}
    }, [desktopDrawerOpen]);

    const desktopDrawerWidth = desktopDrawerOpen ? DESKTOP_DRAWER_WIDTH_OPEN : DESKTOP_DRAWER_WIDTH_MINI;

    const ctx = useContext(AppContext);

    const routes = (
        <React.Suspense fallback={<Box sx={{ p: 2 }}></Box>}>
            <Routes>
                <Route path="*" element={<ErrorPage />} />
                <Route path="/" element={<HomePage />} errorElement={<ErrorPage />}/>
                <Route path="/saison/:id/:source?" element={<SaisonPage />}  />
                <Route path="/matchday/:id" element={<MatchDayPage />} />
                <Route path="/match/:id" element={<MatchPage />} />
                <Route path="/matchdays/:id" element={<MatchDaysPage />} />
                <Route path="/teamplayers/:id" element={<TeamPlayersPage />} />
                <Route path="/administration/:id" element={<AdministrationPage />} />
                <Route path="/players" element={<PlayersPage />} />
                <Route path="/teams" element={<TeamsPage/>} />
                <Route path="/saisons" element={<SaisonsPage />} />
                <Route path="/info/:id" element={<InfoPage />} />
                <Route path="/halloffame" element={<HallOfFame />} />
                <Route path="/impressum" element={<ImpressumPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/team/:id" element={<TeamPage />} />
                <Route path="/teamplayersuggests/:id" element={<TeamPlayerSuggestsPage />} />
                <Route path="/team/:id/:returnUrl" element={<TeamPage />} />
                <Route path="/playerstradelivedashboard/:id" element={<PlayersTradeLivePage />} />
                <Route path="/users" element={<UsersPage />} />
            </Routes>
        </React.Suspense>
    )




    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
 
    const handleLogout = () => {
        HttpService.get("AccountAPI/Logoff").then(res => {
            localStorage.removeItem('token')
            setAnchorEl(null); 
            onLogout();
            navigate("/");
        })

    };

    const handleEditAccount = () => {
        setAnchorEl(null); 
        setOpenAccountDialog(true);
    }

    const handleChangeSize = () => {
        setAnchorEl(null); 
        setOpenChangeSizeDialog(true)
    }

    const handleSaveAccount = () => {
        setOpenAccountDialog(false);
    }

    const handleLogin = () => {
        onLogin();
    }

    const container = window !== undefined ? () => window().document.body : undefined;
    
      const renderNavItem = (
        to: string,
        icon: React.ReactNode,
        label: string,
        mini: boolean,
        options?: { indent?: boolean }
      ) => {
        const button = (
            <ListItemButton
                sx={
                    mini
                        ? { minHeight: 48, justifyContent: 'center', px: 2.5 }
                        : (options?.indent ? { pl: 4 } : undefined)
                }
            >
                <ListItemIcon
                    sx={mini ? { minWidth: 0, mr: 'auto', justifyContent: 'center' } : undefined}
                >
                    {icon}
                </ListItemIcon>
                {!mini && <ListItemText primary={label} />}
            </ListItemButton>
        );
        return (
            <NavLink
                to={to}
                className={({ isActive }) => isActive ? "sidebar-item-active" : "sidebar-item"}
            >
                {mini ? <Tooltip title={label} placement="right">{button}</Tooltip> : button}
            </NavLink>
        );
      };

      const renderDrawer = (mini: boolean, isTemp: boolean = false) => (
        <Box sx={{overflowX: 'hidden', display: 'flex', flexDirection: 'column', minHeight: '100%'}}>
          <Toolbar sx={{ px: mini ? 0.5 : undefined, minHeight: '64px', justifyContent: mini ? 'center' : 'flex-start' }}>
            {mini ? (
                <IconButton
                    aria-label="Menü einblenden"
                    onClick={(e) => {
                        e.stopPropagation();
                        setMobileOpen(true);
                    }}
                    sx={{ color: '#CCCCCC' }}
                >
                    <MenuIcon />
                </IconButton>
            ) : (
                <Box onClick={() => { navigate("/") }} sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                    <img src={Logo2} alt="Logo" style={{height: '2.5em'}} />
                </Box>
            )}
          </Toolbar>
          <Divider />
            {ctx?.saison && (
            <Box>
                <List>
                    <Collapse in={ctx.saison.id !== undefined} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {!mini && (
                                <NavLink
                                    to={`saison/${ctx.saison.id}`}
                                    className="sidebar-item"
                                    >
                                    <ListItemButton>
                                        <ListItemText primaryTypographyProps={{fontSize: '0.75rem'}}  primary={ctx.saison.name?.toUpperCase()}/>
                                    </ListItemButton>
                                </NavLink>
                            )}
                            {renderNavItem(`matchdays/${ctx.saison.id}`, <EventOutlined />, "SPIELTAGE", mini)}
                            {ctx.currentMatchDay && ctx.currentMatchDay.number > 0 && (
                                <Collapse in={true} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {renderNavItem(`matchday/${ctx.currentMatchDay.id}`, <RedoOutlined />, ctx.currentMatchDay.number + ". SPIELTAG", mini, { indent: true })}
                                    </List>
                                </Collapse>
                            )}
                            {renderNavItem(`teamplayers/${ctx.saison.id}`, <GroupsOutlined />, "KADER", mini)}
                            {renderNavItem(`info/${ctx.saison.id}`, <InfoOutlined />, "INFOS", mini)}
                            {renderNavItem(`teamplayersuggests/${ctx.saison.id}`, <Person2Outlined />, "SPIELERPOOL", mini)}
                            {renderNavItem(`playerstradelivedashboard/${ctx.saison.id}`, <SmartDisplayOutlined />, "SPIELERKAUF LIVE", mini)}
                            {ctx.userSaisonAlloc?.allocRole === AllocRole.owner && (
                                renderNavItem(`administration/${ctx.saison.id}`, <SettingsOutlined />, "ADMINISTRATION", mini)
                            )}
                        </List>
                    </Collapse>
                </List>
            </Box>
            )}
            <Box>
            <Divider />
                {account && (
                <List>
                    {renderNavItem(`saisons`, <ListIcon />, "SAISONS", mini)}
                    {renderNavItem(`halloffame`, <EmojiEventsOutlined />, "HALL OF FAME", mini)}
                </List>
                )}
            </Box>
            {props.account?.roles.find(s => s === "ServerAdmin") && (
            <Box>
                <Divider />
                <List>
                    {renderNavItem(`teams`, <GroupsOutlined />, "VEREINE", mini)}
                    {renderNavItem(`users`, <Person2Outlined />, "BENUTZER", mini)}
                </List>
            </Box>
            )}
            <Box sx={{marginTop: 'auto', display: 'flex', flexDirection: 'column'}}>
                {mini ? (
                    <Box sx={{display: {xs: 'none', md: 'flex'}, justifyContent: 'center', px: 0.5, py: 0.5}}>
                        <IconButton
                            aria-label="Sidebar erweitern"
                            onClick={(e) => {
                                e.stopPropagation();
                                setDesktopDrawerOpen(prev => !prev);
                                setMobileOpen(false);
                            }}
                            sx={{ color: '#CCCCCC' }}
                        >
                            <ChevronRightIcon />
                        </IconButton>
                    </Box>
                ) : (
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '15px', paddingRight: 0.5, marginTop: '25px', marginBottom: '15px'}}>
                        <Box sx={{display: 'flex', gap: 1}}>
                            <NavLink to={'impressum'} style={{textDecoration: 'none'}}>
                                <Typography sx={{cursor: 'pointer', textDecoration: 'none', color:'#CCCCCC'}} fontSize={'small'}>Impressum</Typography>
                            </NavLink>
                            <NavLink to={'privacy'} style={{textDecoration: 'none'}}>
                                <Typography sx={{cursor: 'pointer', textDecoration: 'none', color:'#CCCCCC'}} fontSize={'small'}>Datenschutz</Typography>
                            </NavLink>
                        </Box>
                        {!isTemp && (
                            <IconButton
                                aria-label="Sidebar verkleinern"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setDesktopDrawerOpen(prev => !prev);
                                    setMobileOpen(false);
                                }}
                                sx={{ display: {xs: 'none', md: 'inline-flex'}, color: '#CCCCCC' }}
                            >
                                <ChevronLeftIcon />
                            </IconButton>
                        )}
                    </Box>
                )}
            </Box>
        </Box>
      );
      return (
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <AppBar
                    position="fixed"
                    sx={{
                    width: { md: `calc(100% - ${desktopDrawerWidth}px)` },
                    ml: { md: `${desktopDrawerWidth}px` },
                    }}
                >
                    <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { md: 'none' } }}
                    >
                        <MenuIcon sx={{fill: 'rgb(204,204,204)'}}/>
                    </IconButton>
                    <Box sx={{ flexGrow: 1, display: mobileOpen ? 'block' : (desktopDrawerOpen ? { xs: 'none', md: 'inherit' } : 'none') }}></Box>
                    <Box
                        sx={{
                            flexGrow: 1,
                            paddingTop: '0.4em',
                            display: mobileOpen
                                ? 'none'
                                : (desktopDrawerOpen ? { md: 'none' } : 'block'),
                            cursor: 'pointer'
                        }}
                        onClick={() => { navigate("/") }}
                    >
                        <img src={Logo2} alt="Logo" style={{height: '2.5em'}} />
                    </Box>
                    {/* <Box sx={{ flexGrow: 1, display: { md: 'none' }, cursor: 'pointer' }} onClick={() => { navigate("/") }}>
                        <Typography fontWeight='bold' fontSize='x-large' position='absolute' sx={{bottom: '15px', color: '#CCCCCC'}}>
                            MANAGER
                        </Typography>
                        <Typography fontSize='x-small' position='absolute' letterSpacing='1.48rem' sx={{marginLeft: '1px', bottom: '8px', color: '#CCCCCC'}}>
                            SPIEL
                        </Typography>
                        
                    </Box> */}
                    {/* {ctx?.userSaisonAlloc?.allocRole === AllocRole.owner && (
                        <Button color="inherit">ADMIN</Button>
                    )} */}
                    {account && (
                        <Typography sx={{display: {xs: 'none', sm: 'block'}}}>{account.userName}</Typography>
                    )}
                    {!account && (
                        <Button color="inherit" onClick={handleLogin}>Login</Button>
                    )}
                    {account && (
                        <div>
                            {account.imageFileName && (
                                <IconButton
                                    //size="large"
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleMenu}
                                    color="inherit"
                                    
                                >
                                 <ImageComponent 
                                    className= {`avatar`}
                                    width={'36px'}
                                    fileName={'/images/upload/avatar/' + account.imageFileName} 
                                    base64Thumb={account.avatarBase64Thumb}/>

                                {/* <Box className={"avatar"} sx={{minHeight: '36px', minWidth: '36px', backgroundImage:'url(' + HttpService.baseUrl + '/images/upload/avatar/' + account.imageFileName + ')'}}></Box> */}

                                </IconButton>
                            )}
                            {!account.imageFileName && (
                                <IconButton
                                    size="large"
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleMenu}
                                    color="inherit"
                                >
                                    <AccountCircle sx={{fontSize: '36px', fill: 'rgb(204,204,204)'}} />
                                </IconButton>
                            )}

                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={handleEditAccount}>Avatar</MenuItem>
                                <MenuItem onClick={handleChangeSize}>Einstellungen</MenuItem>
                                <MenuItem onClick={handleLogout}>Logout</MenuItem>
                                {/* <MenuItem disabled={true}>
                                    <Box>
                                        <Typography fontSize={'xx-small'}>{process.env.REACT_APP_VERSION}</Typography>
                                    </Box>
                                </MenuItem> */}
                            </Menu>
                        </div>
                    )}
                    </Toolbar>
                </AppBar>
                <Box
                    component="nav"
                    sx={{ width: { md: desktopDrawerWidth }, flexShrink: { md: 0 } }}
                    aria-label="mailbox folders"
                >
                    {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                    <Drawer
                        className='sidebar'
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        onClick={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                        sx={{
                            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: DESKTOP_DRAWER_WIDTH_OPEN, backgroundColor: '#252526', backgroundImage: 'none', color: '#CCCCCC' },
                        }}
                        >
                        {renderDrawer(false, true)}
                    </Drawer>
                    <Drawer
                        className='sidebar'
                        variant="permanent"
                        sx={{
                            display: { xs: 'none', md: 'block' },
                            '& .MuiDrawer-paper': {
                                boxSizing: 'border-box',
                                width: desktopDrawerWidth,
                                overflowX: 'hidden',
                                transition: 'width 200ms ease',
                                backgroundColor: '#252526',
                                backgroundImage: 'none',
                                color: '#CCCCCC',
                                borderRight: 'none',
                                boxShadow: '2px 0px 4px -1px rgba(0,0,0,0.2), 4px 0px 5px 0px rgba(0,0,0,0.14), 1px 0px 10px 0px rgba(0,0,0,0.12)',
                            },
                        }}
                        open
                        >
                        {renderDrawer(!desktopDrawerOpen)}
                    </Drawer>
                </Box>
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 1,
                        width: { md: `calc(100% - ${desktopDrawerWidth}px)` },
                        background: ctx?.themeMode === 'dark'
                            ? 'linear-gradient(160deg, #2a2a2a 0%, #141414 100%)'
                            : '#c5d1c3',
                        minHeight: "100vh",
                        marginBottom: (ctx?.saison ? {xs: '56px', md: '0px'} : '0px'),
                        marginTop: {xs: '56px', md: '64px'},
                    }}
                >
                    {/* <Toolbar /> */}
                    {routes}
                </Box>
                {ctx?.saison && (
                    <BottomNavigation component={'footer'} sx={
                        {
                            display: {md: 'none'}, 
                            position: 'fixed', 
                            zIndex: '1100', 
                            bottom: 0, 
                            right: 0, 
                            width: { xs: '100%', md: `calc(100% - ${240}px)` }, 
                            backgroundColor: '#252526', 
                            color: '#FFFFFF', 
                            boxShadow: '0px -2px 10px 0px rgba(0,0,0,0.2);',
                            "& .MuiBottomNavigationAction-label": {
                                fontSize: '1rem',
                            },
                            
                            "& .MuiBottomNavigationAction-label.Mui-selected": {
                                fontSize: '1.1rem',
                            },

                            "& .MuiBottomNavigationAction-root, .Mui-selected, svg": {
                                color: "#FFFFFF",
                                whiteSpace: 'nowrap'
                            }
                        ,"& .Mui-selected, .Mui-selected > svg": {
                            color: "#2e7d32"
                        }
                        }
                    }
                        showLabels
                        value={
                            (
                                location.pathname.search('saison/') > 0 ? 0 : 
                                location.pathname.search('matchday/' + ctx.currentMatchDay?.id) > 0 ? 1 :
                                location.pathname.search('matchdays/') > 0 ? 2 :
                                location.pathname.search('teamplayers/') > 0 ? 3 :
                                -1
                            )
                        }
                        >
                        <BottomNavigationAction label={'HOME'} icon={<HomeOutlined />} onClick={() => navigate('/saison/' + ctx?.saison?.id)} />
                        {ctx.currentMatchDay && (
                            <BottomNavigationAction label={ctx.currentMatchDay.number + ". SPIELTAG"} icon={<TodayOutlined />} onClick={() => navigate('/matchday/' + ctx?.currentMatchDay?.id)} />
                        )}
                        {!ctx.currentMatchDay && (
                            <BottomNavigationAction label={'SPIELTAGE'} icon={<EventOutlined />} onClick={() => navigate('/matchdays/' + ctx?.saison?.id)} />
                        )}
                        <BottomNavigationAction label={'KADER'} icon={<GroupsOutlined />} onClick={() => navigate('/teamplayers/' + ctx?.saison?.id)} />
                    </BottomNavigation>
                )}
                {account && (
                    <Box>
                        <AccountDialogComponent 
                            open={openAccountDialog}
                            account={account}
                            onSave={handleSaveAccount}
                            onClose={() => setOpenAccountDialog(false)}
                        />
                        <ChangeSizeDialogComponent
                            account={account}
                            open={openChangeSizeDialog}
                            onClose={() => setOpenChangeSizeDialog(false)}
                        />
                    </Box>
                )}
                
            </Box>
            
      );
}

export default ResponsiveDrawer;